import { io, Socket } from 'socket.io-client'
import { refreshAccessToken } from 'api'
import { TOKEN } from 'shared/constants/app'
import { API_URL, SOCKET_URL } from 'shared/constants/urls'

export const getChatSocketOrigin = () => (
  SOCKET_URL || API_URL.replace(/\/api\/?$/, '')
)

// Токен уходит на сервер только при подключении. С истёкшим сервер пускает сокет как гостя —
// без комнат поддержки и магазина, и события молча перестают приходить. Срок по часам
// браузера не проверяем: они бывают сбиты на минуту и больше, поэтому всегда берём новый
const getSocketToken = () => refreshAccessToken().catch(() => localStorage.getItem(TOKEN))

// auth-функцию socket.io зовёт на каждое подключение, в том числе после обрыва (деплой, сон компьютера)
export const createChatSocket = (): Socket => io(
  getChatSocketOrigin(),
  {
    transports: ['websocket', 'polling'],
    auth: (cb) => {
      void getSocketToken().then((token) => cb({ token }))
    }
  }
)
